import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { XdrSearchTabPanelController } from '../controller/XdrSearchTabPanelController';
import { InputQueryConfig } from '../../xdrSearch/types';
import { Target } from '@nirvana/shared/dtos/types/dashboards/common';
import { TimeRangeKind } from '@nirvana/shared/dtos/types/shared/time';
import { LiveSearchPivotingObject } from '../../xdrSearchLive/types';

export class XdrSearchTabPanelComponent extends BaseWebComponentElement {
  public controller: XdrSearchTabPanelController | null;
  protected activeTabId: string | undefined;
  public pivotingParams: LiveSearchPivotingObject | null = null;
  public errorMessage: string | null = null;
  public pivotingToLoadedComponent: boolean | null = null;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: XdrSearchTabPanelController,
    });
  }

  public setActiveTabById(tabId: string): void {
    this.activeTabId = tabId;
    if (this.started) {
      this.controller?.selectActiveTabById(tabId);
    }
  }

  public getActiveTabId(): string | undefined {
    return this.activeTabId;
  }

  public executeQuery(config: InputQueryConfig): void {
    this.controller?.view.dom.$searchApp.executeQuery(config);
  }

  public async setDateFilterTimeFrame(timeFrame) {
    await this.controller?.view.dom.$searchApp.setDateFilterTimeFrame(timeFrame);
  }

  public setCompanyFilter(company: Target) {
    this.controller?.view.dom.$searchApp.controller.setCompanyFilter(company);
    this.controller?.view.dom.$searchLive.controller.setSelectedFilterBasedOnChangedCompany(company);
  }

  public setPivotingParams(pivotingParams: LiveSearchPivotingObject, errorMessage: string, pivotingToLoadedComponent: boolean): void {
    if (errorMessage) {
      this.errorMessage = errorMessage;
      return;
    }

    this.pivotingParams = pivotingParams;
    this.pivotingToLoadedComponent = pivotingToLoadedComponent;
  }
}
